/**
 * WebsiteStickyCTA — fixed bottom mobile bar with Call + Estimate.
 * Hidden on lg+ (desktop nav already shows both).
 */
import { Phone } from 'lucide-react';

export default function WebsiteStickyCTA({ config }) {
  const phone = config.phone_number || '';
  const phoneDisplay = config.phone_display || phone;
  const primary = config.brand?.primary || '#0f4c81';
  const accent = config.brand?.accent || '#f59e0b';

  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-8px_24px_rgba(15,23,42,0.10)] flex"
      data-testid="ws-sticky-cta"
    >
      {phone && (
        <a
          href={`tel:${phone.replace(/\s/g, '')}`}
          className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-bold text-white transition-colors active:bg-slate-800"
          style={{ backgroundColor: primary }}
          data-testid="ws-sticky-call"
        >
          <Phone size={16} /> Call {phoneDisplay}
        </a>
      )}
      <a
        href="#estimate"
        className="flex-1 flex items-center justify-center gap-2 py-4 text-sm font-bold text-slate-900 transition-colors active:opacity-90"
        style={{ backgroundColor: accent }}
        data-testid="ws-sticky-estimate"
      >
        Free Estimate
      </a>
    </div>
  );
}
